import type { MemorySliceDescriptor } from "../../shared";
import { appSessionRestoreSlice } from "./appSessionRestore.slice";
import { bikeStationPopupRequestSlice } from "./bikeStationPopupRequest.slice";
import { drawnItineraryGeometrySlice } from "./drawnItineraryGeometry.slice";
import { exchangeRateSessionSlice } from "./exchangeRateSession.slice";
import { itineraryOfferRefreshSlice } from "./itineraryOfferRefresh.slice";
import { itineraryPanelStateSlice } from "./itineraryPanelState.slice";
import { mapReadySlice } from "./mapReady.slice";
import { navigationSessionSlice } from "./navigationSession.slice";
import { offerPurchaseLoginPromptSlice } from "./offerPurchaseLoginPrompt.slice";
import { purchasedItineraryOpenSlice } from "./purchasedItineraryOpen.slice";
import { routeHistorySlice } from "./routeHistory.slice";
import { servicesBootstrapSlice } from "./servicesBootstrap.slice";
import { ticketPurchaseSlice } from "./ticketPurchase.slice";
import { ticketViewerSlice } from "./ticketViewer.slice";

/**
 * Complete registry of ephemeral session slices.
 */
export const ALL_EPHEMERAL_SLICES = [
    mapReadySlice,
    drawnItineraryGeometrySlice,
    navigationSessionSlice,
    itineraryPanelStateSlice,
    routeHistorySlice,
    exchangeRateSessionSlice,
    bikeStationPopupRequestSlice,
    appSessionRestoreSlice,
    servicesBootstrapSlice,
    offerPurchaseLoginPromptSlice,
    ticketPurchaseSlice,
    itineraryOfferRefreshSlice,
    ticketViewerSlice,
    purchasedItineraryOpenSlice,
] as const satisfies readonly MemorySliceDescriptor<unknown>[];
